<ng-container *ngIf='!!message && !!message.address'>
  <app-page-header title='Bericht bewerken'>
    <button class='btn btn-delete actions' (click)='delete(message.id)'>Bericht verwijderen</button>
  </app-page-header>

  <div class='container mt-3 mb-3'>
    <div class='row'>
      <div class='col'>
        <div class='header mb-3'>
          <h1 class='title'>Contact</h1>
        </div>
      </div>
      <div class='col'>
        <div class='header mb-3'>
          <h1 class='title'>Adres</h1>
        </div>
      </div>
    </div>
    <div class='row'>
      <div class='col'>
        {{ message.address.contact }}<br>
        <ng-container *ngIf='channel === "email"'>
          <a *ngIf='message.address.email' href='mailto:{{message.address.email}}'>{{ message.address.email }}</a>
          <span class='muted' *ngIf='!message.address.email'>Geen e-mailadres bekend</span>
        </ng-container>
        <ng-container *ngIf='channel !== "email"'>
          <a *ngIf='message.address.phoneNumber' href='tel:{{message.address.phoneNumber}}'>
            {{ message.address.phoneNumber }}
          </a>
          <span class='muted' *ngIf='!message.address.phoneNumber'>Geen telefoonnummer bekend</span>
        </ng-container>
      </div>
      <div class='col'>
        {{ message.address.postalCode }}<br>
        {{ message.address.streetAndHouseNumber }}, {{ message.address.city }}
      </div>
    </div>
  </div>

  <div class='container mt-3' *ngIf='templates$ | async as templates'>
    <div class='row message-overview'>
      <div class='config col'>
        <div class='header mb-3'>
          <h1 class='title'>Instellingen</h1>
        </div>
        <div class='form' [formGroup]='form'>
          <div class='form-group mb-2'>
            <label class='label' for='channel'>
              Via welk kanaal versturen?
            </label>
            <select class='form-control' formControlName='channel' id='channel'>
              <option
                *ngFor='let option of channelOptions'
                [value]='option.value'
                [disabled]='!isReachable(option.value)'>
                {{ getChannelOptionLabel(option) }}
              </option>
            </select>
          </div>

          <div class='form-group mb-2' *ngIf='channel !== "email"'>
            <label class='label' for='template'>
              Kies een template
            </label>
            <select class='form-control' formControlName='template' id='template'>
              <option [ngValue]='null'>---- KIES EEN TEMPLATE ----</option>
              <option *ngFor='let template of templates' [ngValue]='template.name'>{{ template.name }}</option>
            </select>
          </div>

          <ng-container *ngIf='channel === "email"'>
            <div class='form-group mb-2'>
              <label class='label' for='subject'>
                Onderwerp
              </label>
              <input class='form-control' type='text' id='subject' formControlName='subject'>
            </div>
            <div class='form-group mb-2 d-flex custom-text'>
              <input
                type='checkbox'
                id='useCustomText'
                #customText
                [checked]='useCustomText'
                (change)='toggleCustomText(customText.checked)'>
              &nbsp;
              <label class='label' for='useCustomText'>Eigen tekst in plaats van het standaard sjabloon</label>
            </div>
            <div class='form-group mb-2' *ngIf='useCustomText'>
              <label class='label' for='body'>
                Bericht
              </label>
              <textarea
                class='form-control'
                id='body'
                formControlName='message'
                cdkAutosizeMinRows='4'
                cdkAutosizeMaxRows='12'
                cdkTextareaAutosize></textarea>
            </div>
          </ng-container>

          <div class='form-group'>
            <label class='label' for='scheduled'>
              Wanneer moet het bericht verstuurd worden?
            </label>
            <input class='form-control' type='datetime-local' id='scheduled' formControlName='scheduled'>
          </div>
        </div>
        <div class='col mt-2'>
          <div class='body actions'>
            <button class='btn btn-success' (click)='submit()' [disabled]='!canSubmit()'>Opslaan</button>
            <button class='btn btn-primary' (click)='submit(true)' [disabled]='!canSubmit()'>Nu versturen</button>
          </div>
        </div>
        <div class='col mt-2' *ngIf='message.report'>
          <div class='body'>
            <ng-container *ngIf='prefix$ | async as prefix'>
              <a
                class='btn btn-secondary'
                style='display: inline-block'
                routerLink='/{{prefix}}/reports/{{message.report.id}}'
                target='_blank'>
                Melding bekijken
              </a>
            </ng-container>
          </div>
        </div>
      </div>
      <div class='preview col'>
        <div class='header mb-3'>
          <h1 class='title'>Preview</h1>
        </div>
        <div class='message'>
          <div class='subject' *ngIf='channel === "email" && form.value.subject'>
            {{ form.value.subject }}
          </div>
          <!-- Both channels ignore the body whenever a template is set, so the preview follows suit. -->
          <div *ngIf='form.value.template else customBody'>
            <div class='template' *ngIf='previewTemplate else emailPreview'>
              <div class='text'>{{ previewTemplate.bodyText }}</div>
              <ul class='buttons' *ngFor='let button of previewTemplate.buttons'>
                <ng-container *ngIf='button.type === "URL"'>
                  <li>
                    <a [href]='button.url' target='_blank'>{{ button.text }}</a>
                  </li>
                </ng-container>
                <ng-container *ngIf='button.type === "PHONE_NUMBER"'>
                  <li>
                    <a href='tel:{{button.phone_number}}'>{{ button.text }}</a>
                  </li>
                </ng-container>
              </ul>
            </div>
            <ng-template #emailPreview>
              <div class='text muted'>
                Standaard reviewverzoek ({{ form.value.template }}). De inhoud staat vast in de mailtemplate.
              </div>
            </ng-template>
          </div>
          <ng-template #customBody>
            <div class='text' *ngIf='form.value.message else noBody'>
              <app-message [content]='form.value.message'></app-message>
            </div>
            <ng-template #noBody>
              <div class='text muted'>Nog geen inhoud: kies een template of typ een eigen tekst.</div>
            </ng-template>
          </ng-template>
          <div class='time'>
            {{ message.scheduled | date:'yyyy-MM-dd HH:mm' }}
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>
